// extracted by mini-css-extract-plugin
export default {"headMark":"HeadMark_headMark__6MGNZ"};